import React, { useEffect, useState } from 'react';
import './Privacypolicy.css';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const PrivacyPolicy = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "Privacy Policy - Funfillia";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/metaTags/privacy_policy', {
          headers: {
            Accept: 'application/json',
            'Client-Domain':'www.funfillia.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching privacy policy meta tags:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Funfillia</title>

        {/* General Meta */}
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="privacy-policy">
        <div className="privacy-container">
          <h1>Privacy Policy</h1>
          <p><strong>Last updated:</strong> April 9, 2025</p>

          <p>
            Welcome to <strong>Funfillia</strong>, your go-to blog for fun, entertainment, and light-hearted stories! 
            This Privacy Policy outlines how we collect, use, and protect your information when you visit our website.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect the following information:</p>
          <ul>
            <li>Email address (only when you subscribe)</li>
            <li>Anonymous usage data (via Google Analytics or similar tools)</li>
            <li>Browser and device information</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Improve user experience on the site</li>
            <li>Send newsletters if you subscribe</li>
            <li>Monitor website traffic and blog performance</li>
          </ul>

          <h2>3. Cookies</h2>
          <p>
            Funfillia uses cookies to enhance your browsing experience. You can disable cookies through your browser settings if preferred.
          </p>

          <h2>4. Third-Party Services</h2>
          <p>
            We may use third-party tools like Google Analytics for insights and social sharing features. These tools may collect limited information as per their privacy policies.
          </p>

          <h2>5. Data Protection</h2>
          <p>
            We prioritize your privacy and use security measures to protect your data. However, no online service is 100% secure.
          </p>

          <h2>6. Your Rights</h2>
          <p>You may request to:</p>
          <ul>
            <li>Unsubscribe from our mailing list</li>
            <li>Delete your stored data (if any)</li>
          </ul>

          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this policy from time to time. We encourage you to review this page periodically.
          </p>

          <h2>8. Contact Us</h2>
          <p>
            For questions or concerns about this Privacy Policy, please contact us at: <strong><a href="mailto:info@funfillia.com">info@funfillia.com</a></strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
